import { DefaultCommandProps } from './index';

import Base from './base';

const Date = ({ label, value, onChange }: DefaultCommandProps) => (
  <Base id={label} value={value as string} onChange={(e) => onChange(label, e)} type="date" />
);

export default Date;
